import { Button } from "bootstrap";
import { Card } from "primereact/card";
import { Panel } from 'primereact/panel';
import { Divider } from "primereact/divider";

import "./ClientMenu.css"
import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Form } from 'react-bootstrap';
import EstadosGlobal from "./EstadosGlobal"

import { getUrl } from "../../../../ApiCall/GetUrl";


import { useNavigate , useLocation } from "react-router-dom";

export default function ClientMenu() {

  // Variable id para debugear
  const id = 1;


  // Hooks de los selects
  const [especialidades, setEspecialidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudad, setCiudad] = useState([]);

  const [estado, setEstado] = useState(null)
  // Peticiones a la base de datos

  const location = useLocation() // Aqui vienen los parametros del cliente registrado
  // { state : { id : response.id , name : response.name , logg_express : response.logg_express , isLawyer : document.getElementById("soyAbogado").checked }} )
  const navigate = useNavigate() ;

  function onClickConsulta()
  {



    navigate( "/express" , { state : location.state })
  }

  useEffect(() => {
    axios.get( getUrl() + "/get_especialidades_express").then(response => {
      setEspecialidades(response.data);
      console.log("Este es el response.data: ", response.data)
    }).catch(error => {
      console.log("Error fetching data: ", error)
      setEspecialidades(["Hubo un error al obtener la información"])
    });
  }, []);


  // Declaración de el useForm()
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm();

  return <>
    <div className="container mt-5">
      <Panel className="mt-5" header="Agenda una cita">
        <h3>Agenda tu cita desde hoy</h3>
        <Form>
          <div className="row">
            <EstadosGlobal setEstado={setEstado} register={register} especialidades={especialidades} errors={errors} id={id} />
          </div>
        </Form>
      </Panel>
      <Panel className="mt-5" header="Consulta Express">
        <p>Descripción de consulta express</p>
        <a className="btn btn-primary" onClick={onClickConsulta}>¿Tienes dudas respecto a un tema legal?</a>
      </Panel>
      <Panel className="mt-5" header="Genera un documento">
        <p>Descripción de genera un documento</p>
        <a className="btn btn-primary">Genera tu documento</a>
      </Panel>
    </div>
  </>
}
